var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 45,
    stroke: "#F6B119",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5795 26.4057L51.5854 25.8999H51.0795H45.7645H45.2582L45.2645 26.4061L45.6481 57.1582L45.6542 57.6519H46.148H50.7234H51.2176L51.2234 57.1577L51.5795 26.4057ZM45.9571 63.9517L45.9571 63.9516L45.9515 63.9586C45.3769 64.6671 45.1001 65.528 45.1001 66.51C45.1001 67.4587 45.3803 68.2982 45.9515 69.0026L45.9514 69.0026L45.9571 69.0094C46.586 69.7572 47.4913 70.0999 48.5864 70.0999C49.6651 70.0999 50.5586 69.7561 51.1855 69.0128C51.7964 68.3098 52.1001 67.4668 52.1001 66.51C52.1001 65.5203 51.8002 64.6558 51.1855 63.9483C50.5586 63.205 49.6651 62.8612 48.5864 62.8612C47.4913 62.8612 46.586 63.2039 45.9571 63.9517Z",
    fill: "#1A1A1A",
    stroke: "#F7CB17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationmark);
export default __webpack_public_path__ + "static/media/Exclamationmark.59e491dedc99ea2ee1a90ceb5ab2e4fe.svg";
export { ForwardRef as ReactComponent };